import React from 'react';
import { CTAButton, CHECKOUT_URL, PRICE_FULL, PRICE_SHORT, Section } from './Shared';
import { DnaHelix, TreeOfLife } from './BioDecor';
export function EmotionalClose() {
  return <Section className="max-w-4xl" data-id="element-64" data-mp="vmcv1csg3ofj">
      <div className="relative overflow-hidden rounded-3xl border border-emerald-200 bg-emerald-50 p-6 text-center md:p-12" data-id="element-65" data-mp="vlbc6m56txn9">
        <DnaHelix className="pointer-events-none absolute -left-4 -top-6 h-40 w-20 text-blue-400/30" data-id="element-66" data-mp="qn00e5vc1d2e" />
        <TreeOfLife className="pointer-events-none absolute -bottom-8 -right-4 h-48 w-28 text-emerald-500/25" data-id="element-67" data-mp="mmznwqrsnbxz" />
        <div className="relative" data-id="element-68" data-mp="hoy4g4qghalz">
          <h2 className="mb-6 text-3xl font-bold leading-tight text-blue-900 md:text-4xl" data-id="element-69" data-mp="cmyzwrizc7ng">
            Your next session can be different.
          </h2>
          <div className="mx-auto mb-10 max-w-2xl space-y-4 text-base leading-relaxed text-slate-700 md:text-lg" data-id="element-70" data-mp="7qicy0ninzby">
            <p data-id="element-71" data-mp="26z5k2ftupyrw">There are two versions of you at this moment.</p>
            <p data-id="element-72" data-mp="222yg2sl0mxcl">
              <strong className="text-blue-900" data-id="element-73" data-mp="220c8isy4khud">One</strong> closes this page and continues entering sessions
              without a clear pathway. Still improvising the first questions. Still searching for a closing practice
              at the end. Still carrying every session alone in memory.
            </p>
            <p className="font-semibold text-emerald-700" data-id="element-74" data-mp="2v6plxin98qhm">
              And the other decides that today is the day their practice becomes more organised, more confident,
              and more sustainable.
            </p>
            <p className="text-lg italic text-amber-700 md:text-xl" data-id="element-75" data-mp="3ssmx0uzb1tjj">
              The question is not whether you can invest in a system.
              <br data-id="element-76" data-mp="3e2o2d26yl08t" />
              The question is how many more sessions you want to work without one.
            </p>
          </div>

          <div className="mx-auto max-w-md rounded-2xl border-2 border-amber-500/60 bg-white p-6 shadow-lg" data-id="element-77" data-mp="3izxoa7v52trw">
            <span className="relative -top-9 inline-block rounded-full bg-blue-900 px-3 py-1 text-xs font-bold text-amber-200" data-id="element-78" data-mp="fd73a6p5b1to">
              ⭐ MOST CHOSEN
            </span>
            <h3 className="-mt-4 text-xl font-bold text-blue-900" data-id="element-79" data-mp="p7370a5wph04">
              🏆 BIODECODING PRACTITIONER KIT™
            </h3>
            <p className="mt-3 text-sm text-slate-500" data-id="element-80" data-mp="g895c5dpy0fp">
              Regular Price: <span className="line-through" data-id="element-81" data-mp="galryvuf8yz3">{PRICE_FULL}</span>
            </p>
            <div className="my-2 flex items-center justify-center gap-3" data-id="element-82" data-mp="b8wktrabl5ga">
              <p className="text-4xl font-bold text-emerald-700" data-id="element-83" data-mp="6bd32heeyajl">{PRICE_SHORT}</p>
              <span className="rounded-full bg-amber-400 px-2.5 py-0.5 text-xs font-bold text-blue-950" data-id="element-84" data-mp="1j364hevsa7t">60% OFF</span>
            </div>
            <p className="mb-2 text-sm font-semibold text-slate-700" data-id="element-85" data-mp="3sqfo2ynl8ros">3 Core Volumes + 5 Bonuses · 245 Pages</p>
            <p className="mb-5 text-sm leading-relaxed text-slate-500" data-id="element-86" data-mp="3oq5ihn3pk3ag">
              The complete practitioner system of session frameworks, integration practices, ethical communication,
              question resources, and post-session tools.
            </p>
            <CTAButton href={CHECKOUT_URL} variant="gold" fullWidth className="text-sm md:text-base" data-id="element-87" data-mp="1u8vtsksquxpz">
              → GET THE BIODECODING PRACTITIONER KIT FOR {PRICE_SHORT}
            </CTAButton>
            <p className="mt-4 text-[11px] text-slate-500" data-id="element-88" data-mp="2460gclqi4v7b">
              🛡️ 7-Day Guarantee · 📥 Immediate Download · 🔒 Secure Checkout
            </p>
          </div>
        </div>
      </div>
    </Section>;
}